var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightBarMuted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    viewBox: "0 0 312 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ranking-bar-gradient-light-mode-filtered",
    x1: "0%",
    y1: 3,
    x2: "100%",
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5d0e27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#641129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6c1c2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#73252f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7c2d32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#823837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#894139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#914b3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#98533f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#a05e43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#a66645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ad6f47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#b5794b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#bc814c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#c58b51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#cc9353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d29d57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#dba75a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#e2af5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#eaba61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f2c365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#edc366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e9c367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#e6c167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#e5c368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#e2c269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ddc26b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#dbc26c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#d8c26f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#d5c270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#d0c070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#cdc171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#c9bf72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#c5bf73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#c3bf75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#c0bf75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#bcbf76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#b9be79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#b5be7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3bf7b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBarMuted);
export default __webpack_public_path__ + "static/media/LightBarMuted.03fc3c69.svg";
export { ForwardRef as ReactComponent };